import { render, staticRenderFns } from "./VisualizarPlanosBeneficios.vue?vue&type=template&id=a27809b4&"
import script from "./VisualizarPlanosBeneficios.vue?vue&type=script&lang=js&"
export * from "./VisualizarPlanosBeneficios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports